import { Vector3D } from "../../../../../../script/lod2";

export class Overview3dHelper {
    static projectPointVerticallyOntoTriangle(P, A, B, C) {

        // Quickly return if no projection
        const triangle = [A, B, C];
        if (!(
            triangle.find(point => P.x >= point.x) &&
            triangle.find(point => P.x <= point.x) &&
            triangle.find(point => P.y >= point.y) &&
            triangle.find(point => P.y <= point.y)
        )) {
            return undefined;
        }

        // Plane normal
        const AB = B.subtract(A);
        const AC = C.subtract(A);
        const n = AB.cross(AC);

        // Check if normal.z == 0 → triangle is vertical
        if (Math.abs(n.z) < 1e-9) {
            return undefined;
        }

        // Compute t for vertical projection
        const AP = P.subtract(A);
        const t = n.dot(AP) / n.z;

        // Projected point on plane
        const Pproj = new Vector3D(P.x, P.y, P.z - t);

        // Barycentric coordinate test
        const v0 = C.subtract(A);
        const v1 = B.subtract(A);
        const v2 = Pproj.subtract(A);

        const dot00 = v0.dot(v0);
        const dot01 = v0.dot(v1);
        const dot02 = v0.dot(v2);
        const dot11 = v1.dot(v1);
        const dot12 = v1.dot(v2);

        const denom = dot00 * dot11 - dot01 * dot01;
        const invDenom = 1 / denom;

        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;

        const inside = u >= 0 && v >= 0 && u + v <= 1;

        return inside ? Pproj.z : undefined;
    }
}